import * as React from "react";
import { useState, useEffect } from "react";
import CustomLabel from "../controls/CustomLabel";
import "./../../assets/css/AddPrescriptionItem.scss";
import { inputTypes } from "../../enum/inputTypes";
import VaccineVector from "./../../assets/images/VaccineVector.svg";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import useTitanApp from "../../hooks/useTitanApp";

function VaccineDosageItem({
  template,
  number,
  active,
  UpdateNmsModel,
  groupId,
}) {
  const { nmsServiceState } = useTitanApp();
  const {  timelineElements } = nmsServiceState || {};
  const { userControls, sectionTitle } = template || {};
  const [expanded, setExpanded] = useState(false);
  const [inputValues, setInputValues] = useState(userControls);

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 15,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(9px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(12px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: "#1976d2",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(["width"], {
        duration: 200,
      }),
    },
    "& .MuiSwitch-track": {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: "#444",
      boxSizing: "border-box",
    },
  }));

  const handleToggleExpand = (id) => {
    setExpanded((prev) => (prev === id ? null : id));
  };

  const handleFormChange = async (index, event, type, labelName, itemValue) => {
    let value;
    let updatedTimelineElements;
    if (type === "Radio") {
      const itemValue = event.target.checked ? "true" : "false";
      value = itemValue;

      // Retrieve the existing element index in the timelineElements array
      const existingElementIndex = timelineElements.findIndex(
        (element) => element.title === sectionTitle
      );

      if (itemValue === "false" && existingElementIndex !== -1) {
        // Remove the item if the switch is false and the element exists
        const updatedListItems = timelineElements[
          existingElementIndex
        ].listItems.filter((item) => item.label !== labelName);

        const updatedTimelineElement = {
          ...timelineElements[existingElementIndex],
          listItems: updatedListItems,
        };

        updatedTimelineElements = [
          ...timelineElements.slice(0, existingElementIndex),
          updatedTimelineElement,
          ...timelineElements.slice(existingElementIndex + 1),
        ];

        //setCurrentTimelineElements(updatedTimelineElements);
      } else if (itemValue === "true") {
        // Add the item if the switch is true
        const timelineListItemObj = {
          label: labelName,
          value: itemValue,
          type: type,
        };

        if (existingElementIndex !== -1) {
          // If the title exists, merge the list items
          const updatedListItems = [
            ...timelineElements[existingElementIndex].listItems,
            timelineListItemObj,
          ];

          const updatedTimelineElement = {
            ...timelineElements[existingElementIndex],
            listItems: updatedListItems,
          };

          updatedTimelineElements = [
            ...timelineElements.slice(0, existingElementIndex),
            updatedTimelineElement,
            ...timelineElements.slice(existingElementIndex + 1),
          ];

          //setCurrentTimelineElements(updatedTimelineElements);
        } else {
          // If the title doesn't exist, create a new object
          const timelineElementsObj = {
            name: sectionTitle,
            title: sectionTitle,
            value: sectionTitle,
            listItems: [timelineListItemObj],
            elementType: 8,
          };

          updatedTimelineElements = [...timelineElements, timelineElementsObj];
          // setCurrentTimelineElements(updatedTimelineElements);
        }
      }
    } else if (type === "date") {
      value = event.toISOString();
      const timelineElementsObj = {
        name: sectionTitle,
        title: value,
        value: value,
        listItems: [],
        elementType: 8,
      };

      updatedTimelineElements = [...timelineElements, timelineElementsObj];
    } else {
      value = event?.target?.value;
      const existingElementIndex = timelineElements.findIndex(
        (element) => element.title === sectionTitle
      );

      const timelineListItemObj = {
        label: labelName,
        value: value,
        type: type,
      };

      let updatedListItems;

      if (existingElementIndex !== -1) {
        // If the title exists, merge the list items
        const listitems = timelineElements[existingElementIndex].listItems;
        let otherIndex = listitems.findIndex(
          (item) => item.label === labelName
        );
        if (otherIndex !== -1) {
          updatedListItems = listitems?.map((item, index) => {
            if (index === otherIndex) {
              // Modify the specific element at otherIndex
              return {
                ...item,
                value: value,
              };
            }
            return item;
          });
        } else {
          updatedListItems = [
            ...timelineElements[existingElementIndex].listItems,
            timelineListItemObj,
          ];
        }

        const updatedTimelineElement = {
          ...timelineElements[existingElementIndex],
          listItems: updatedListItems,
        };

        updatedTimelineElements = [
          ...timelineElements.slice(0, existingElementIndex),
          updatedTimelineElement,
          ...timelineElements.slice(existingElementIndex + 1),
        ];

        // setCurrentTimelineElements(updatedTimelineElements);
      } else {
        // If the title doesn't exist, create a new object
        const timelineElementsObj = {
          name: sectionTitle,
          title: sectionTitle,
          value: sectionTitle,
          listItems: [timelineListItemObj],
          elementType: 7,
        };

        updatedTimelineElements = [...timelineElements, timelineElementsObj];
        // setCurrentTimelineElements(updatedTimelineElements);
      }
    }
    const UserControlObj = await setUserControl(index, value);
    UpdateNmsModel(
      sectionTitle,
      UserControlObj,
      groupId,
      updatedTimelineElements
    );
  };

  const setUserControl = async (index, value) => {
    let newUserControl;
    setInputValues((prevInputValues) => {
      const updatedData = prevInputValues.map((item, i) =>
        i === index ? { ...item, value } : item
      );
      newUserControl = updatedData;
      return updatedData;
    });
    return newUserControl;
  };

  return (
    <div
      className="parent_template ps-add-template"
      style={{
        borderLeft: "2px solid #00ca69",
      }}
    >
      <div className="medicine-card customcard">
        <div
          className="card-step-number"
          style={{
            background: "#00ca69",
          }}
        >
          <h2>{number}</h2>
        </div>
        <div className="card-content ps-add-item">
          <div className="card-actions nms-title">
            <div className="d-flex">
              <VaccineVector />
              <h2 class="medicine-card-heading">{sectionTitle}</h2>
            </div>
          </div>

          {inputValues.map((parentItem, index) => {
            if (
              parentItem?.userControlId !==
                "00000000-0000-0000-0000-000000000000" &&
              parentItem?.parentUserControlId === null
            ) {
              return (
                <Accordion
                  key={parentItem?.userControlId}
                  className="custom-accordion"
                  expanded={expanded === parentItem.userControlId}
                >
                  <AccordionSummary
                    aria-controls="panel-content"
                    id="panel-header"
                  >
                    <div className="accordianHeaderContainer membersSchedule_header">
                      <p className="accordion-dosage-title">
                        {parentItem.label}
                      </p>
                      <div className="accordion-dosage-switch">
                        <AntSwitch
                          checked={expanded === parentItem.userControlId}
                          onChange={(event) => {
                            handleToggleExpand(parentItem.userControlId); // First function
                            handleFormChange(
                              index,
                              event,
                              inputTypes[parentItem.type],
                              parentItem.label,
                              event.target.checked
                            ); // Second function
                          }}
                          inputProps={{ "aria-label": "ant design" }}
                        />
                      </div>
                    </div>
                  </AccordionSummary>
                  {inputValues.map((item, inbox) => {
                    if (
                      parentItem?.userControlId === item?.parentUserControlId
                    ) {
                      return (
                        <AccordionDetails
                          key={`${item.userControlId}-${inbox}`}
                          className="accordion-det-temp"
                        >
                          {item.type === 5 && (
                            <div>
                              <div
                                style={{
                                  border: item.required
                                    ? "1px solid #E22424"
                                    : "#00ca69",
                                }}
                                className="switch-content-reports-outer toggle-only ps-inner-switch-content"
                                onClick={() =>
                                  handleFormChange(
                                    inbox,
                                    {
                                      target: {
                                        checked: !JSON.parse(item?.value),
                                      },
                                    },
                                    inputTypes[item?.type],
                                    item?.label,
                                    item?.value
                                  )
                                }
                              >
                                <CustomLabel name={item.label} />
                                <div>
                                  <AntSwitch
                                    inputProps={{
                                      "aria-label": "ant design",
                                    }}
                                    onChange={(event) =>
                                      handleFormChange(
                                        inbox,
                                        event,
                                        inputTypes[item.type],
                                        item.label,
                                        item.value
                                      )
                                    }
                                    checked={
                                      item.value === ""
                                        ? false
                                        : JSON.parse(item.value)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          )}

                          {item.type === 0 && (
                            <div className="template_control">
                              <TextField
                                className="template_input text_input_field ps-input-field"
                                required
                                id="outlined-required"
                                value={item.value}
                                label={item.label}
                                onChange={(event) =>
                                  handleFormChange(
                                    inbox,
                                    event,
                                    inputTypes[item.type],
                                    item.label,
                                    event.target.value
                                  )
                                }
                                inputProps={{ maxLength: 5000 }}
                              />
                            </div>
                          )}

                          {item.type === 3 && (
                            <div className="template_control">
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  className="template_input text_input_field ps-input-field"
                                  label={item.label}
                                  value={
                                    item.value
                                      ? dayjs(item.value, "M/D/YYYY h:mm:ss A")
                                      : dayjs("17.04.2022", "DD.MM.YYYY")
                                  }
                                  format="DD/MM/YYYY"
                                  onChange={(newValue) =>
                                    handleFormChange(
                                      inbox,
                                      newValue, // Convert to string format
                                      inputTypes[item.type],
                                      item.label,
                                      item.value
                                    )
                                  }
                                />
                              </LocalizationProvider>
                            </div>
                          )}
                        </AccordionDetails>
                      );
                    }
                  })}
                </Accordion>
              );
            }
            return null;
          })}
        </div>
      </div>
    </div>
  );
}

export default VaccineDosageItem;

